import React, { forwardRef } from 'react';
import classnames from 'classnames';
import s from './StickyContent.scss';
var StickyContent = forwardRef(function (_a, innerRef) {
    var isStuck = _a.isStuck, className = _a.className, zIndex = _a.zIndex, _b = _a.marginTop, marginTop = _b === void 0 ? 0 : _b, _c = _a.marginLeft, marginLeft = _c === void 0 ? 0 : _c, _d = _a.top, top = _d === void 0 ? 0 : _d, children = _a.children;
    return (React.createElement("div", { className: classnames(s['content'], isStuck && s['stuck'], isStuck && className), style: {
            zIndex: zIndex,
            marginTop: isStuck ? marginTop : undefined,
            marginLeft: isStuck ? marginLeft : undefined,
            top: isStuck ? top : undefined,
        }, ref: innerRef }, children(isStuck)));
});
StickyContent.displayName = 'StickyContent';
export default React.memo(StickyContent);
//# sourceMappingURL=StickyContent.js.map